import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    View,
    StyleSheet,
    TouchableOpacity,
    Animated,
    PanResponder
} from 'react-native'

import STYLES from '../../constants/styles'

export default class Modal extends Component {
    static propTypes = {
        open: PropTypes.bool,
        animationDuration: PropTypes.number,
        animationTension: PropTypes.number,
        modalDidOpen: PropTypes.func,
        modalDidClose: PropTypes.func,
        closeOnTouchOutside: PropTypes.bool,
        disableOnBackPress: PropTypes.bool
    }

    static defaultProps = {
        open: false,
        animationDuration: 1200,
        animationTension: 40,
        modalDidOpen: () => undefined,
        modalDidClose: () => undefined,
        closeOnTouchOutside: true,
        disableOnBackPress: false
    }

    constructor(props) {
        super(props)

        this.state = {
            phase: new Animated.ValueXY({ x: 0, y: STYLES.HEIGHT })
        }

        this._pandResponder = PanResponder.create({
            onStartShouldSetPanResponderCapture: (evt, gestureState) => false,
            onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
            onPanResponderTerminationRequest: (evt, gestureState) => false,
            onPanResponderGrant: (evt, gestureState) => {
                this.state.phase.setOffset({
                    x: this.state.phase.x._value,
                    y: this.state.phase.y._value
                })

                this.state.phase.setValue({ x: 0, y: 0 })
            },
            onPanResponderMove: (evt, gestureState) => {
                Animated.event([null, {
                    dy: this.state.phase.y
                }])(evt, { dy: Math.max(gestureState.dy, 0) })
            },
            onPanResponderRelease: (evt, gestureState) => {
                this.state.phase.flattenOffset()

                if (
                    (Math.abs(this.state.phase.y._value) > STYLES.HEIGHT/4) ||
                    gestureState.vy > 1.5
                ) {
                    this.close()
                } else {
                    this.open()
                }
            }
        })
    }

    componentWillMount() {
        if (this.props.open) {
            this.setState({ children: this.props.children })
            this.open()
        }
    }

    componentWillReceiveProps(props) {
        if (props.open && props.children !== this.state.children) {
            this.setState({ children: props.children })
        }

        if (props.open !== this.props.open) {
            if (props.open) {
                this.open()
            } else {
                this.close()
            }
        }
    }

    executeCallbacks(didOpen) {
        if (didOpen) {
            this.props.modalDidOpen()
        } else {
            this.setState({ open: false, children: undefined })
            this.props.modalDidClose()
        }
    }

    open() {
        this.setState({ open: true })
        Animated.timing(
            this.state.phase,
            {
                toValue: { x: 0, y: 0 },
                duration: this.props.animationDuration
            }
        ).start(
            () => {
                this.executeCallbacks(true)
            }
        )
    }

    close() {
        Animated.timing(
            this.state.phase,
            {
                toValue: { x: 0, y: STYLES.HEIGHT },
                duration: this.props.animationDuration
            }
        ).start(
            () => {
                this.setState({ open: false })
                this.executeCallbacks(false)
            }
        )
    }

    render() {
        const { phase, open, children } = this.state
        const { containerStyle, closeOnTouchOutside, modalStyle } = this.props

        let containerStyles = [StyleSheet.absoluteFillObject, containerStyle]

        if (!this.state.open) {
            containerStyles.push({
                top: -10000,
                left: 0,
                height: 0,
                width: 0
            })
        }

        return (
            <View pointerEvents={open ? 'auto' : 'none'} style={containerStyles}>
                <TouchableOpacity
                    style={StyleSheet.absoluteFillObject}
                    disabled={!closeOnTouchOutside}
                    onPress={this.close.bind(this)}
                    activeOpacity={0.75}>
                        <Animated.View style={{
                                flex: 1,
                                opacity: phase.y.interpolate({
                                    inputRange: [0, STYLES.HEIGHT],
                                    outputRange: [1, 0]
                                }),
                                backgroundColor: STYLES.BACKDROP_COLOR }} />
                </TouchableOpacity>

                <Animated.View
                    style={[
                        {
                            width: modalStyle && modalStyle.width
                                ? modalStyle.width
                                : STYLES.WIDTH,
                            height: modalStyle && modalStyle.height
                                ? modalStyle.height
                                : STYLES.HEIGHT,
                            transform: [{
                                translateY: this.state.phase.y
                            }]
                        }
                    ]}
                    // {...this._pandResponder.panHandlers}
                    >
                        {children}
                </Animated.View>
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/index.js